// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nuxt-content[data-v-ac3768e2]{margin-bottom:2rem}.nuxt-content ol[data-v-ac3768e2],.nuxt-content ul[data-v-ac3768e2]{list-style-position:inside;margin-bottom:1rem}.nuxt-content p[data-v-ac3768e2]{margin-bottom:1rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
